import { Link } from "react-router-dom";

export default function Logo({ className = "" }) {
  return (
    <Link to="/" className={`logo ${className}`} aria-label="KIZAK home">
      <span className="logo-word">KIZAK</span>
      <sup>TM</sup>
    </Link>
  );
}